import { observer } from "mobx-react-lite";
import { keyboardStore } from "../../mainStore/keyBoardStore";
import { useEffect, useRef } from "react";
import styles from "./keyboard.module.css";

const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0"];

export const Keyboard = observer(() => {
  const wrapperRef = useRef(null);

  const handlePress = (value) => {
    keyboardStore.type(value);
  };

  const handleBackspace = () => {
    keyboardStore.typeBackspace();
  };

  const close = () => {
    keyboardStore.close();
  };

  useEffect(() => {
    keyboardStore.keyBoardWrapperElement = wrapperRef.current;
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={`${styles.wrapper} keyboard-wrapper`}
      style={{
        visibility: keyboardStore.isOpen ? "unset" : "hidden",
      }}
    >
      <div className={styles.keypad}>
        {keys.map((key) => (
          <button key={key} className={styles.key} onClick={() => handlePress(key)}>
            {key}
          </button>
        ))}

        <button className={styles.key} onClick={handleBackspace}>
          ⌫
        </button>
        <button className={`${styles.key} need-to-blur`} onClick={close}>
          <svg
            style={{ pointerEvents: "none" }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
        <button
          id="keyboard-ok-btn"
          className={`${styles.key} ${styles.keyOk} keyboard-ok-btn need-to-blur`}
          onClick={close}
        >
          Ok
        </button>
      </div>
    </div>
  );
});
